import './SearchResults.scss'

import React, { HTMLProps } from 'react'
import { useTranslation } from 'react-i18next'

import RecordedWebinarType from '../RecordedWebinarType'
import SectionZeroState from '../sections/SectionZeroState'
import UpcomingWebinarType from '../UpcomingWebinarType'
import VideoType from '../VideoType'
import useSearchQuery from './useSearchQuery'

export interface SearchResultsProps extends HTMLProps<HTMLDivElement> {
  clearSearchInput: ()=> void
  searchResults?: RecordedWebinarType[] | UpcomingWebinarType[] | VideoType[]
}

export default function SearchResults(props: SearchResultsProps) {
  const { clearSearchInput, searchResults, ...otherProps } = props
  const [t] = useTranslation()
  const search = useSearchQuery()
  const hasResults = searchResults && searchResults.length > 0

  return (
    <div className="search-results" {...otherProps}>
      {hasResults ? (
        t('home.search.results', { search })
      ) : (
        <>
          {t('home.search.noResults', { search })}
          <SectionZeroState.ClearButton className="search-results__clear" onClick={clearSearchInput}>
            {t('home.search.clearSearch')}
          </SectionZeroState.ClearButton>
        </>
      )}
    </div>
  )
}
